module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/icon_resume_title_wh-9ef9cbf0ff6b2ecb7a9d46be13e460fd.png";